export default __webpack_public_path__ + "static/media/NSL_COVID_safe_plan.1a2d1d82.pdf";